import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "../../hooks/useTranslation";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import GavelIcon from "@mui/icons-material/Gavel";

interface RepresentationStepProps {
  hasAttorney: string;
  onChange: (field: string, value: string) => void;
}

const RepresentationStep: React.FC<RepresentationStepProps> = ({
  hasAttorney,
  onChange,
}) => {
  const { t } = useTranslation();

  const options = [
    {
      value: "NO",
      label: t("form.secondQuestion.option1"),
      icon: PersonSearchIcon,
      color: {
        main: "#3b82f6",
        light: "#eff6ff",
        border: "#bfdbfe",
        hover: "#dbeafe",
      },
    },
    {
      value: "YES",
      label: t("form.secondQuestion.option2"),
      icon: GavelIcon,
      color: {
        main: "#8b5cf6",
        light: "#faf5ff",
        border: "#d8b4fe",
        hover: "#f3e8ff",
      },
    },
  ];

  return (
    <Box>
      <Typography
        variant="subtitle2"
        align="center"
        sx={{
          color: "#9ca3af",
          fontWeight: 500,
          mb: 2,
          fontSize: "0.875rem",
        }}
      >
        Question 2 out of 5
      </Typography>

      <Typography
        variant="h4"
        align="center"
        sx={{
          mb: 4,
          fontWeight: 700,
          color: "#1e293b",
          fontSize: { xs: "1.2rem", md: "1.5rem" },
        }}
      >
        2. {t("form.secondQuestion.question")}
        <span style={{ color: "#ef4444" }}>*</span>
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {options.map((option) => {
          const isSelected = hasAttorney === option.value;
          const Icon = option.icon;

          return (
            <Button
              key={option.value}
              onClick={() => onChange("hasAttorney", option.value)}
              sx={{
                padding: "1.5rem",
                borderRadius: "12px",
                border: `2px solid ${
                  isSelected ? option.color.main : option.color.border
                }`,
                backgroundColor: isSelected
                  ? option.color.light
                  : "transparent",
                display: "flex",
                alignItems: "center",
                gap: 2,
                justifyContent: "flex-start",
                textTransform: "none",
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor: option.color.hover,
                  borderColor: option.color.main,
                },
              }}
            >
              <Icon
                sx={{
                  fontSize: 32,
                  color: option.color.main,
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  fontSize: { xs: "1rem", md: "1.125rem" },
                  fontWeight: 500,
                  color: "#334155",
                  textAlign: "left",
                }}
              >
                {option.label}
              </Typography>
            </Button>
          );
        })}
      </Box>
    </Box>
  );
};

export default RepresentationStep;
